import { render, staticRenderFns } from "./header_divider.vue?vue&type=template&id=6b5d95c6"
import script from "./header_divider.vue?vue&type=script&lang=js"
export * from "./header_divider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports